// Users Flow Action Types
export const GET_AWARD_DETAILS_REQUEST = 'awards/GET_AWARD_DETAILS_REQUEST';
export const GET_AWARD_DETAILS_SUCCESS = 'awards/GET_AWARD_DETAILS_SUCCESS';
export const GET_AWARD_DETAILS_FAILURE = 'awards/GET_AWARD_DETAILS_FAILURE';
export const GET_AWARD_DETAILS_RESET = 'awards/GET_AWARD_DETAILS_RESET';

export const ADD_AWARD_NOMINATION_REQUEST = 'awards/ADD_AWARD_NOMINATION_REQUEST';
export const ADD_AWARD_NOMINATION_SUCCESS = 'awards/ADD_AWARD_NOMINATION_SUCCESS';
export const ADD_AWARD_NOMINATION_FAILURE = 'awards/ADD_AWARD_NOMINATION_FAILURE';
export const ADD_AWARD_NOMINATION_RESET = 'awards/ADD_AWARD_NOMINATION_RESET';

export const CREATE_ORDER_AWARD_NOMINATION_REQUEST = 'awards/CREATE_ORDER_AWARD_NOMINATION_REQUEST';
export const CREATE_ORDER_AWARD_NOMINATION_SUCCESS = 'awards/CREATE_ORDER_AWARD_NOMINATION_SUCCESS';
export const CREATE_ORDER_AWARD_NOMINATION_FAILURE = 'awards/CREATE_ORDER_AWARD_NOMINATION_FAILURE';
export const CREATE_ORDER_AWARD_NOMINATION_RESET = 'awards/CREATE_ORDER_AWARD_NOMINATION_RESET';

export const VERIFY_AWARD_NOMINATION_PAYMENT_REQUEST = 'awards/VERIFY_AWARD_NOMINATION_PAYMENT_REQUEST';
export const VERIFY_AWARD_NOMINATION_PAYMENT_SUCCESS = 'awards/VERIFY_AWARD_NOMINATION_PAYMENT_SUCCESS';
export const VERIFY_AWARD_NOMINATION_PAYMENT_FAILURE = 'awards/VERIFY_AWARD_NOMINATION_PAYMENT_FAILURE';
export const VERIFY_AWARD_NOMINATION_PAYMENT_RESET = 'awards/VERIFY_AWARD_NOMINATION_PAYMENT_RESET';

export const ADD_AWARD_SHORTLISTED_DETAILS_REQUEST = 'awards/ADD_AWARD_SHORTLISTED_DETAILS_REQUEST';
export const ADD_AWARD_SHORTLISTED_DETAILS_SUCCESS = 'awards/ADD_AWARD_SHORTLISTED_DETAILS_SUCCESS';
export const ADD_AWARD_SHORTLISTED_DETAILS_FAILURE = 'awards/ADD_AWARD_SHORTLISTED_DETAILS_FAILURE';
export const ADD_AWARD_SHORTLISTED_DETAILS_RESET = 'awards/ADD_AWARD_SHORTLISTED_DETAILS_RESET';

export const RESET_AWARD_BILLING = 'awards/RESET_AWARD_BILLING';

// Admin Flow Action Types
export const GET_AWARDS_LIST_REQUEST = 'awards/GET_AWARDS_LIST_REQUEST';
export const GET_AWARDS_LIST_SUCCESS = 'awards/GET_AWARDS_LIST_SUCCESS';
export const GET_AWARDS_LIST_FAILURE = 'awards/GET_AWARDS_LIST_FAILURE';
export const GET_AWARDS_LIST_RESET = 'awards/GET_AWARDS_LIST_RESET';

export const GET_NOMINATION_LIST_REQUEST = 'awards/GET_NOMINATION_LIST_REQUEST';
export const GET_NOMINATION_LIST_SUCCESS = 'awards/GET_NOMINATION_LIST_SUCCESS';
export const GET_NOMINATION_LIST_FAILURE = 'awards/GET_NOMINATION_LIST_FAILURE';
export const GET_NOMINATION_LIST_RESET = 'awards/GET_NOMINATION_LIST_RESET';

export const GET_NOMINATION_DETAILS_REQUEST = 'awards/GET_NOMINATION_DETAILS_REQUEST';
export const GET_NOMINATION_DETAILS_SUCCESS = 'awards/GET_NOMINATION_DETAILS_SUCCESS';
export const GET_NOMINATION_DETAILS_FAILURE = 'awards/GET_NOMINATION_DETAILS_FAILURE';
export const GET_NOMINATION_DETAILS_RESET = 'awards/GET_NOMINATION_DETAILS_RESET';

export const GET_AWARDS_CATEGORY_LIST_REQUEST = 'awards/GET_AWARDS_CATEGORY_LIST_REQUEST';
export const GET_AWARDS_CATEGORY_LIST_SUCCESS = 'awards/GET_AWARDS_CATEGORY_LIST_SUCCESS';
export const GET_AWARDS_CATEGORY_LIST_FAILURE = 'awards/GET_AWARDS_CATEGORY_LIST_FAILURE';
export const GET_AWARDS_CATEGORY_LIST_RESET = 'awards/GET_AWARDS_CATEGORY_LIST_RESET';

export const UPDATE_NOMINATION_REQUEST = 'awards/UPDATE_NOMINATION_REQUEST';
export const UPDATE_NOMINATION_SUCCESS = 'awards/UPDATE_NOMINATION_SUCCESS';
export const UPDATE_NOMINATION_FAILURE = 'awards/UPDATE_NOMINATION_FAILURE';
export const UPDATE_NOMINATION_RESET = 'awards/UPDATE_NOMINATION_RESET';